
/* Afaque's test config */
const awsmobile = {
  Auth: {
    region: 'ap-south-1',
    /*Dev Config*/
    /*userPoolId: 'ap-south-1_SaF2xMSkf',
    userPoolWebClientId: '2v7r77ve5cbr27j1ik5guqt6ue',*/
    /*Test Config*/
    userPoolId: 'ap-south-1_le1XjFOhi',
    userPoolWebClientId: '2u2pil2ao1tkb9tva5vb7nebde',
  },
  API: {
    endpoints: [
        {
            name: "PutUserInfo",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test"
        },
        {
            name: "GetUserInfo",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test",

        },
        {
            name: "CreateNewOrder",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test/orders",

        },
        {
            name: "UpdateOrderByOrderId",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test/orders",

        },
        {
            name: "GetOrderByOrderId",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test/orders",

        },
        {
            name: "GetPaymentToken",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test/payments/token?",

        },
        {
            name: "UpdateOrderByNotify",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test/payments/notify",

        },
        {
            name: "GetAllOrdersByUser",
            endpoint: "https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test/orders",

        }
    ]
  }
};


export default awsmobile;
